
const digest = '4a9121c14c1a4af8133b7552434f507e49e40f2221a0ce3f0f7b2297bc21d15a';
const css = `._anchorPlaceholder_ps15y_1 {
  width: 100%;
}

._anchor_ps15y_1._fullScreen_ps15y_5 {
  /**
    * We don't need to mess with calculating position and scrolling
    * for fullscreen toolbars, because they'll always be 40px from
    * the top and 100% wide. so we can hardcode the appropriate
    * values here (rather than reparenting the nodes the anchor looks
    * for)
    */
  top: 41px !important;
  position: fixed !important;
  width: 100% !important;
  z-index: 1 !important;
  transform: none !important;
  /* Hide the floating toolbar spacer, if it exists. */
  & + :last-child {
    display: none;
  }
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"anchorPlaceholder":"_anchorPlaceholder_ps15y_1","anchor":"_anchor_ps15y_1","fullScreen":"_fullScreen_ps15y_5"};
export { css, digest };
  